import { defaultTimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/constants.tsx';

export const INITIAL_STATE = {
	cards: [],
	columnCounts: {
		toDo: 0,
		inProgress: 0,
		done: 0,
	},
	isEpicIssueTypeAvailable: false,
	epicIssueType: {
		id: 0,
		name: 'Epic',
		hasRequiredFields: false,
	},
	epicIssueTypeName: 'Epic',
	timeTrackingOptions: defaultTimeTrackingOptions,
	isRankingEnabled: false,
	isInitialised: false,
	loading: false,
};

export const STORY_POINTS = 'STORY_POINTS';
export const ORIGINAL_ESTIMATE = 'ORIGINAL_ESTIMATE';
export const CUSTOM_NUMBER_FIELD = 'CUSTOM_NUMBER_FIELD';
export const ISSUE_COUNT = 'ISSUE_COUNT';
